import {select, fork, take, put, takeEvery} from 'redux-saga/effects';
import {fetchRequest} from '@computerrock/formation-core';
import * as applicationActionTypes from '../applicationActionTypes';
import * as dashboardActionTypes from '../../dashboard/dashboardActionTypes';

function* waitForSports() {
    while (true) {
        const {sports} = yield select(state => state.dashboard);
        const {sportId} = yield select(state => state.application);
        if (sports && sports.length > 0 && sportId) {
            return;
        }
        yield take([applicationActionTypes.SET_SPORT_ID, dashboardActionTypes.STORE_SPORTS]);
    }
}

function* handleFeedback({payload}) {
    const {name, email, text} = payload;

    yield* waitForSports();

    const {serviceManager} = yield select(state => state.application);
    const ftemStrapiService = serviceManager.loadService('ftemStrapiService');
    const {sportId} = yield select(state => state.application);
    const {sports} = yield select(state => state.dashboard);

    if (!name || !email || !text || !sportId || !sports || sports.length === 0) {
        console.log('Validation failed:', {name, email, text, sportId, sports});
        return;
    }


    const getSportDocId = sports.find(sport => sport.idNum == sportId)?.documentId;
    if (!getSportDocId) {
        console.log('No matching sport found for sportId:', sportId);
        return;
    }

    const data = {data: {...payload, sport: getSportDocId}};

    yield fork(
        fetchRequest,
        applicationActionTypes.SEND_FEEDBACK_REQUEST,
        ftemStrapiService.postFeedback,
        {data},
    );

    const responseAction = yield take([
        applicationActionTypes.SEND_FEEDBACK_SUCCESS,
        applicationActionTypes.SEND_FEEDBACK_ERROR,
    ]);

    if (!responseAction.error && responseAction.type === applicationActionTypes.SEND_FEEDBACK_SUCCESS) {
        yield put({
            type: applicationActionTypes.STORE_FEEDBACK_RESPONSE,
        });
    } else {
        yield put({
            type: applicationActionTypes.SEND_FEEDBACK_ERROR,
        });
    }
}

function* postFeedback() {
    yield takeEvery(applicationActionTypes.START_FEEDBACK_REQUEST, handleFeedback);
}

export default postFeedback;
